module.exports = __webpack_public_path__ + "img/expand.b336ca4e.svg";